import {Button, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import styles from "./StripeForm.module.css";
import HookForm from "../../components/common/HookForm";
import {DialogTitle, Grid, Stack, Typography} from "@mui/material";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import TextInput from "../../components/common/inputs/TextInput";
import axios from "axios";
import {useQueryClient} from "react-query";

type FormData = {
    id: 0;
    stripeaccountname: string;
    stripeaccountid: string;
}

const StripeForm = ({isOpen, setIsOpen, stripeAccountData}) => {
    const formMethods = useForm<FormData>()
    const { reset } = formMethods
    const queryClient = useQueryClient()

    useEffect(()=> {
        reset(stripeAccountData)
    }, [stripeAccountData])

    const onSubmit = async (formData: FormData) => {
        console.log(formData)
        const { data } = await axios.put('/stripe', {"stripeid": formData.id, "stripeaccountname": formData.stripeaccountname})
        const parsedData = JSON.parse(data.jsonString)
        queryClient.invalidateQueries(['stripesettings'])
        setIsOpen(false)
    }
    const handleCloseModal = () => {
        setIsOpen(false);
    }

    return (
        <>
            <Dialog open={isOpen} onClose={handleCloseModal}
                    className={styles.dialog}>
                <DialogTitle>Stripe Account</DialogTitle>
                <DialogContent>
                <HookForm
                    methods={formMethods}
                    onSubmit={onSubmit}
                    className={styles.form}
                    formProps={{id: 'Stripe-form'}}>
                                    <TextInput
                                        name="stripeaccountname"
                                        label="Account Name"
                                    />
                                    <TextInput
                                        name="stripeaccountid"
                                        label="Account Id"
                                        disabled={true}
                                        required
                                    />
                    <DialogActions>
                        <Button onClick={handleCloseModal} color="primary">
                            Cancel
                        </Button>
                        <Button color="primary" type="submit" variant="contained">
                            Save
                        </Button>
                    </DialogActions>
                </HookForm>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default StripeForm